<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_4"></a>First published in 2007 by</p>
<p class="copy">New Holland Publishers (UK) Ltd</p>
<p class="copy">London • Cape Town • Sydney • Auckland</p>
<table>
<tbody><tr>
<td><p class="copy">Garfield House</p></td>
<td><p class="copy">Unit 1, 66 Gibbes Street</p></td>
</tr>
<tr>
<td><p class="copy">86–88 Edgware Road</p></td>
<td><p class="copy">Chatswood</p></td>
</tr>
<tr>
<td><p class="copy">London W2 2EA</p></td>
<td><p class="copy">NSW 2067</p></td>
</tr>
<tr>
<td><p class="copy"><a href="https://www.newhollandpublishers.com" target="_blank">www.newhollandpublishers.com</a></p></td>
<td><p class="copy">Australia</p></td>
</tr>
</tbody></table>
<table>
<tbody><tr>
<td><p class="copy">80 McKenzie Street</p></td>
<td><p class="copy">218 Lake Road</p></td>
</tr>
<tr>
<td><p class="copy">Cape Town 8001</p></td>
<td><p class="copy">Northcote, Auckland</p></td>
</tr>
<tr>
<td><p class="copy">South Africa</p></td>
<td><p class="copy">New Zealand</p></td>
</tr>
</tbody></table>
<p class="copy1">Copyright © 2007 text and photographs: New Holland Publishers (UK)Ltd</p>
<p class="copy">Copyright © 2007 New Holland Publishers (UK)Ltd</p>
<p class="copy1">Joy Skipper has asserted her moral right to be identified as the author of this work.</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior written permission of the publishers and copyright holders.</p>
<p class="copy1">ISBN 978 184537 781 6</p>
<p class="copy1">Senior Editor:Clare Sayer</p>
<p class="copy">Photographer: Ian Garlick</p>
<p class="copy">Designer: Ian Sandom</p>
<p class="copy">Food Styling: Stella Murphy</p>
<p class="copy">Production: Marion Storz</p>
<p class="copy">Editorial Direction: Rosemary Wilkinson</p>
<p class="copy1">Reproduction by Pica Digital PTE Ltd, Singapore</p>
<div class="page-break">
<p class="imaget"><a id="page_5"></a><img alt="Illustration" src="images/f0005-01.jpg"/></p>
<div class="page-break">
<p class="imaget"><a id="page_6"></a><img alt="Illustration" src="images/f0006-01.jpg"/></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6ad90c39